/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { fn } from "@ember/helper";
import { computed } from "@ember/object";
import { tagName } from "@ember-decorators/component";
import ComboBox from "discourse/select-kit/components/combo-box";
import { i18n } from "discourse-i18n";

@tagName("")
export default class RemindAssignsFrequency extends Component {
  @computed(
    "user.custom_fields.remind_assigns_frequency",
    "siteSettings.remind_assigns_frequency"
  )
  get selectedFrequency() {
    if (
      this.availableFrequencies
        .map((freq) => freq.value)
        .includes(this.user?.custom_fields?.remind_assigns_frequency)
    ) {
      return this.user?.custom_fields?.remind_assigns_frequency;
    }

    return this.siteSettings?.remind_assigns_frequency;
  }

  @computed("user.reminders_frequency")
  get availableFrequencies() {
    return this.user?.reminders_frequency?.map((freq) => ({
      name: i18n(freq.name),
      value: freq.value,
      selected: false,
    }));
  }

  <template>
    <div ...attributes>
      {{#if this.siteSettings.assign_enabled}}
        <div class="controls controls-dropdown">
          <label>{{i18n
              "discourse_assign.reminders_frequency.description"
            }}</label>
          <ComboBox
            @content={{this.availableFrequencies}}
            @id="remind-assigns-frequency"
            @onChange={{fn
              (mut this.user.custom_fields.remind_assigns_frequency)
            }}
            @value={{this.selectedFrequency}}
            @valueProperty="value"
          />
        </div>
      {{/if}}
    </div>
  </template>
}
